import React from 'react'

import type { CollectionLaneProps } from './types'

const CollectionLane = <T,>({
  collection,
  children,
}: CollectionLaneProps<T>) => {
  return collection.content?.length > 0 ? (
    <div className="collections-set__item" key={collection.slug}>
      {children}
    </div>
  ) : null
}

export default CollectionLane
